import React, { createContext, useContext, useState } from "react";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [pageState, setPageState] = useState({});

  const savePageState = (path, data) => {
    setPageState((prev) => ({
      ...prev,
      [path]: {
        ...prev[path],
        ...data,
      },
    }));
  };

  const getPageState = (path) => {
    return pageState[path] || {};
  };

  const clearPageState = (path) => {
    setPageState((prev) => {
      const updated = { ...prev };
      delete updated[path];
      return updated;
    });
  };

  return (
    <AdminContext.Provider
      value={{
        pageState,
        savePageState,
        getPageState,
        clearPageState,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
